
import { Component, Prop, Vue } from "vue-property-decorator";
import TipsContainer from "@/components/tips/TipsContainer.vue";
import { UnitType } from "@/schemas/Enums";
import DynamicScore from "@/components/feedback/components/DynamicScore.vue";
import ChatBubble from "@/components/task/common/chat/ChatBubble.vue";
import AutoDebriefing from "@/components/feedback/Debriefing/AutoDebriefing.vue";

@Component({
  name: "testPage",
  computed: {},
  methods: {},
  components: {
    ChatBubble,
    DynamicScore,
    TipsContainer,
    AutoDebriefing,
  },
})
export default class testPage extends Vue {
  data(): any {
    return {
      message: {
        session_id: this.sessionId,
        author_id: "dc446e1c-1851-4c29-8eb1-17c3bb24def3",
        content: "N'hésitez pas à partager vos idées sur les objets à classer",
        type: "text",
        author_nickname: "bot",
      },
    };
  }

  handleFinished(answers) {
    console.log("Réponses :", answers);

    // 👉 ici tu peux appeler une API
  }

  get isCarousel(): {
    carousel_tips: boolean;
    carousel_tip_unit?: UnitType;
    carousel_display_time?: number;
    carousel_occurrence?: number;
  } {
    // return this.setting
    //   ? {
    //       carousel_tips: this.setting?.carousel_tips,
    //       carousel_tip_unit: this.setting?.carousel_tip_unit,
    //       carousel_display_time: this.setting?.carousel_display_time || 1,
    //       carousel_occurrence: this.setting?.carousel_occurrence || 1,
    //     }
    //   : { carousel_tips: false };
    return {
      carousel_tips: true,
      carousel_tip_unit: "display_time",
      carousel_display_time: this.setting?.carousel_display_time || 1,
      carousel_occurrence: this.setting?.carousel_occurrence || 1,
    };
  }
}
